import { call, put, all } from "redux-saga/effects";
import { ACTIONS, APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* GetCountryList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.COMMON.GET_COUNTRY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            if (Object.keys(data).length == 0) {
                yield put({
                    type: ACTIONS.MASTER.COUNTRY,
                    payload: resp.data?.items?.map((countrylist: any) => {
                        return {
                            label: countrylist.countryName,
                            value: countrylist.countryId,
                            data: countrylist,
                        };
                    }),
                });
            }
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetCountyList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.COMMON.GET_COUNTY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            if (Object.keys(data).length == 0) {
                yield put({
                    type: ACTIONS.MASTER.COUNTY,
                    payload: resp.data?.countyList?.map((countylist: any) => {
                        return {
                            label: countylist.countyName + " - " + countylist.stateName,
                            value: countylist.cuntyID,
                            data: countylist,
                        };
                    }),
                });
            }
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetStateList(action: any): any {
    try {
        const data = action.payload;
        const countryID = typeof data.countryId !== `undefined` ? data.countryId : 0;
        delete data.countryId;
        const resp = yield call(CallApi.GET, APIS.COMMON.GET_STATE + `/${countryID}`, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            yield put({
                type: ACTIONS.MASTER.STATES,
                payload: resp.data?.items?.map((state: any) => {
                    return {
                        label: state.stateName,
                        value: state.stateId,
                        data: state,
                    };
                }),
            });
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetCityList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.COMMON.GET_CITY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            if (Object.keys(data).length == 0) {
                yield put({
                    type: ACTIONS.MASTER.CITY,
                    payload: resp.data.cityList.map((citylist: any) => {
                        return {
                            label: citylist.cityName,
                            value: citylist.cityID,
                        };
                    }),
                });
            }
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* locationSearch(action: any): any {
    const yieldPuts = [{ type: ACTIONS.CATEGORIES.LOCATION_SEARCH, payload: "items" }];
    yield call(sagaFunction, action, CallApi.GET, APIS.COMMON.LOCATION_SEARCH, action.payload, true, yieldPuts);
}

export function* lookupValues(action: any): any {
    const yieldPuts = [{ type: ACTIONS.MASTER.LOOKUP_VALUES }];
    yield call(sagaFunction, action, CallApi.POST, APIS.COMMON.LOOKUP_VALUES, action.payload, true, yieldPuts);
}

export function* uploadImage(action: any): any {
    try {
        const formData = new FormData();
        if (action.payload.file) {
            formData.append("file", action.payload.file);
        }

        // Add any additional fields if provided
        if (action.payload.fileName) {
            formData.append("fileName", action.payload.fileName);
        }
        if (action.payload.folder) {
            formData.append("folder", action.payload.folder);
        }

        const resp = yield call(CallApi.POST, APIS.STORAGE.UPLOAD_IMAGE, formData, true);

        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.statusMessage || "Upload failed");
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetCurrencyList(action: any): any {
    const yieldPuts = [{ type: ACTIONS.CATEGORIES.GET_CURRENCY, payload: "" }];
    yield call(sagaFunction, action, CallApi.GET, APIS.COMMON.GET_CURRENCY, action.payload, true, yieldPuts);
}

export function* GetTimezones(action: any): any {
    const yieldPuts = [{ type: ACTIONS.MASTER.TIMEZONES, payload: "" }];
    yield call(sagaFunction, action, CallApi.GET, APIS.COMMON.GET_TIMEZONES, action.payload, true, yieldPuts);
}
